<template>
  <v-simple-table>
    <thead>
      <tr>
        <th>Preview</th>
        <th>File Name</th>
        <th>Public Id</th>
        <th>Conversion Status</th>
        <th>Created At</th>
        <th>Updated At</th>
      </tr>
    </thead>
    <tbody
      v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="disableListScroll"
    >
      <tr class="no-data" v-if="list.length === 0 && !loading">
        <td colspan="6" class="text-center headline grey--text py-12">
          NO DATA
        </td>
      </tr>
      <tr
        v-for="row in list"
        :key="row.id"
        class="clickable"
        @click="showDetails(row)"
      >
        <td>
          <PreviewRes
            :src="row.thumbnail_url"
            :originalFileName="row.original_file_name"
          />
        </td>
        <td>{{ row.original_file_name }}</td>
        <td>{{ row.public_id }}</td>
        <td>
          <v-chip
            small
            :color="getStatusColor(row.conversion_status)"
            text-color="white"
          >
            {{ formatStatus(row.conversion_status) }}
          </v-chip>
        </td>
        <td>{{ formatDateTime(row.created_at) }}</td>
        <td>{{ formatDateTime(row.updated_at) }}</td>
      </tr>

      <tr class="table-skeleton-loader" v-if="loading">
        <td class="pl-0">
          <v-skeleton-loader type="list-item" />
        </td>
        <td class="pr-0">
          <v-skeleton-loader type="list-item" />
        </td>
        <td class="pr-0">
          <v-skeleton-loader type="list-item" />
        </td>
        <td class="pr-0">
          <v-skeleton-loader type="list-item" />
        </td>
        <td class="pr-0">
          <v-skeleton-loader type="list-item" />
        </td>
        <td class="pr-0">
          <v-skeleton-loader type="list-item" />
        </td>
        <td class="pr-0" v-if="assigning">
          <v-skeleton-loader type="list-item" />
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import dayjs from 'dayjs'
import infiniteScroll from 'vue-infinite-scroll'
import { mdiDotsVertical } from '@mdi/js'
import PreviewRes from './PreviewRes.vue'

export default {
  components: {
    PreviewRes,
  },
  name: 'ListTable',

  directives: {
    infiniteScroll,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    assigning: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
      required: true,
    },
    meta: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      icons: {
        action: mdiDotsVertical,
      },
    }
  },

  computed: {
    disableListScroll() {
      return this.loading || this.meta.current_page >= this.meta.last_page
    },
  },

  methods: {
    loadMore() {
      this.$emit('loadMore', this.meta.current_page + 1)
    },

    showDetails(row) {
      this.$emit('showDetails', row)
    },
    formatDateTime(datetime) {
      return dayjs.utc(datetime).format('YYYY-MM-DD HH:mm:ss')
    },
    getStatusColor(status) {
      const statusColors = {
        pending: 'orange',
        processing: 'blue',
        completed: 'green',
        failed: 'red',
        cancelled: 'grey',
      }
      return statusColors[status] || 'grey'
    },
    formatStatus(status) {
      return status ? status.charAt(0).toUpperCase() + status.slice(1) : ''
    },
  },
}
</script>
